<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list>
      <v-list-item-group v-model="item">
        <v-list-item
          :disabled="item.disabled ? true : false"
          :to="item.to"
          v-for="item in displayableItems"
          :key="item.id"
          exact-active-class="active-link"
        >
          <v-list-item-icon class="mr-2">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    item: null,
    items: [
      // {
      //   text: "Schedule Central",
      //   icon: "mdi-calendar-clock",
      //   to: { name: "ScheduleCentral" },
      // },
      {
        id: "calendar",
        text: "Calendar",
        icon: "mdi-calendar",
        to: { name: "Calendar" },
      },
      {
        id: "course-management",
        text: "Courses",
        to: { name: "CourseManagement" },
        icon: "mdi-database",
      },
      // {
      //   icon: "mdi-clipboard-text-play-outline",
      //   text: "Orders",
      //   to: { name: "Orders" },
      // },
      { icon: "mdi-human-male-board", text: "Teachers", to: { name: "Teachers" } },
      // { icon: "mdi-school", text: "Students", to: { name: "Student" } },
      { icon: "mdi-calendar-account-outline", text: "Staff Schedule", to: { name: "StaffSchedule" } },
      { icon: "mdi-file-chart", text: "Reports", to: { name: "Reports" } },
      { icon: "mdi-human-handsup", text: "Attendance", to: { name: "Attendance" } },
      {
        text: "Standards",
        icon: "mdi-vector-polyline",
        to: { name: "Standards" },
      },
      { text: "Manage API", icon: "mdi-api", to: { name: "ManageApi" } },
      // { text: "Data Engine", link: "/secure/dataengine", icon: "mdi-engine" },
      {
        text: "Manage Resources",
        icon: "mdi-file-cog-outline",
        to: { name: "ManageResources" },
      },
    ],
  }),

  computed: {
    ...mapGetters(["navState", "isLoggedIn", "currentUser"]),
    displayableItems() {
      const routes = this.$router.options.routes;

      return this.items.filter((item) => {
        const route = routes.find((r) => item.to.name == r.name);
        if (route) {
          if (route.meta && route.meta.authorize) {
            return this.isAuthorized(route.meta.authorize);
          } else {
            return true;
          }
        } else {
          return null;
        }
      });
    },
  },
  methods: {
    isAuthorized(roles) {
      if(this.currentUser){
        const userRoles = this.currentUser.roles;

        if (!roles || roles.length < 1) {
          return true;
        }
        if (userRoles && userRoles.length > 0) {
          return userRoles.some((r) => roles.includes(r));
        } else {
          // this.addErrorMessage("Unauthorized Access");
          return false;
        }
      }
      else{
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.active-link{
  color: var(--v-primary-base);
}
</style>